import { Button, Form, Grid, Input, Select } from 'antd';
import { ContentFilters } from 'components';
import { StandardItemsWrapper } from 'components/content-filters/content-filters.styles';
import { NotificationCustomerFilterFormField, NotificationCustomerFilterFormValues, SAVENotificationCustomerFilterFormValues } from 'features/notification/components/type';
import { useGetDropDownData } from 'features/notification/use-cases/get-common-api-data';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
const { useBreakpoint } = Grid;

type UsersFilterFormProps = {
  formId: string;
  handleFilter: (values: SAVENotificationCustomerFilterFormValues) => void;
  initialValues: SAVENotificationCustomerFilterFormValues;
  closeModal?: () => void;
};

export const NotificationCustomerFilterForm = ({
  formId,
  handleFilter,
  initialValues,
  closeModal,
}: UsersFilterFormProps) => {
  const [validateTrigger, setValidateTrigger] = useState(['onSubmit']);
  const [form] = Form.useForm<NotificationCustomerFilterFormValues>();
  const { t } = useTranslation();
  const screens = useBreakpoint();
  const [eventSearchKey, setEventSearchKey] = useState("");
  const [categorySearchKey, setCategorySearchKey] = useState("");

  const { data: sportsCategory, isFetching: sportscatgeory } = useGetDropDownData({
    flag: "sportcategory",
    searchId: 0,
    SearchKey: ""
  }, {
    refetchOnWindowFocus: false,
    refetchOnMount: false
  });
  const { data: coustomerType } = useGetDropDownData({
    flag: "customertype",
    searchId: 0,
    SearchKey: ""
  }, {
    refetchOnWindowFocus: false,
    refetchOnMount: false
  });
  const { data: eventList, isLoading: eventLoading, isFetching: eventFetching } = useGetDropDownData({
    flag: "events",
    searchId: 0,
    SearchKey: eventSearchKey
  }

  );

  const { data: categoryList, isLoading: categoryLoading, isFetching: categoryIsFetching } = useGetDropDownData({
    flag: "eventcategory",
    searchId: 0,
    SearchKey: categorySearchKey
  }, {
    enabled: !!categorySearchKey && categorySearchKey?.trim().length > 0
  });

  const { data: gender, isLoading: genderLoading } = useGetDropDownData({
    flag: "gender",
    searchId: 0,
    SearchKey: ""
  }, {
    refetchOnWindowFocus: false,
    refetchOnMount: false
  });

  const { data: ageGroupCategory, isLoading: ageGroupLoading } = useGetDropDownData({
    flag: "age",
    searchId: 0,
    SearchKey: ""
  }, {
    refetchOnWindowFocus: false,
    refetchOnMount: false
  });

  const { data: nationality } = useGetDropDownData({
    flag: "country",
    searchId: 0,
    SearchKey: ""
  }, {
    refetchOnWindowFocus: false,
    refetchOnMount: false
  });


  const onReset = () => {
    form.resetFields();
    handleFilter({
      ...initialValues,
    });
  };
  const onFinish = (formValues: NotificationCustomerFilterFormValues) => {
    const payload = {
      ...formValues,
      SportCategoryIds: formValues.SportCategoryIds?.join(","),
      EventIds: formValues.EventIds?.join(","),
      TicketCategoryIds: formValues.TicketCategoryIds?.join(","),
      AgeGroupIds: formValues.AgeGroupIds?.join(","),
      
      
    };
    handleFilter(payload);
    closeModal?.();
  };

  useEffect(() => {
    handleFilter({
      ...initialValues,
    });
  }, []);

  useEffect(() => {
    if (coustomerType?.notificationDropDownList?.length) {
      const participant = coustomerType.notificationDropDownList.find(
        (item: any) => item.id === 1
      );

      if (participant) {
        form.setFieldsValue({
          [NotificationCustomerFilterFormField.CustomerTypeId]: participant.id.toString(),
        });

      }
    }
  }, [coustomerType, form]);
  const isSearchEnabledEvent = !!eventSearchKey?.trim();
  const event_loading = isSearchEnabledEvent && (eventLoading || eventFetching);
  const isSearchEnabledCategory = !!categorySearchKey && categorySearchKey?.trim().length > 0;
  const category_loading = isSearchEnabledCategory && (categoryLoading || categoryIsFetching);

  return (

    <Form<NotificationCustomerFilterFormValues>
      id={formId}
      name={formId}
      className='filters-form'
      form={form}
      layout='vertical'
      onFinish={onFinish}
      initialValues={initialValues}
      onFinishFailed={() => {
        setValidateTrigger(['onChange']);
      }}
      validateTrigger={validateTrigger}
    >
      <ContentFilters.FormItemsWrapper style={{ width: '100%' }}>
        <StandardItemsWrapper style={{ width: '100%', flexWrap: 'wrap' }}>
          <Form.Item<NotificationCustomerFilterFormValues>
            label={'Search Customer'}
            name={NotificationCustomerFilterFormField.CustomerSearch}
          >
            <Input
              placeholder={'Enter Name'}
            // disabled={userDisabled}
            />
          </Form.Item>
          <Form.Item<NotificationCustomerFilterFormValues>
            label={'Search Email'}
            name={NotificationCustomerFilterFormField.Email}
          >
            <Input
              placeholder={'Enter Email'}
            // disabled={userDisabled}
            />
          </Form.Item>
          <Form.Item<NotificationCustomerFilterFormValues>
            label={'Sports Type'}
            name={NotificationCustomerFilterFormField.SportCategoryIds}
          >
            <Select
              mode="multiple"
              loading={sportscatgeory}
              placeholder="Please select"
              style={{ width: "210px" }}
              className='cstm_select'

              options={sportsCategory?.notificationDropDownList?.map((res: any) => ({
                label: res.title,
                value: res.id
              }))}
              // disabled={userDisabled || sportscatgeory}
              onChange={(values: number[]) => {
                const searchKey = values.join(",");
                setEventSearchKey(searchKey);

              }}
              maxTagCount={1} // show up to 3 tags
              maxTagPlaceholder={(omittedValues) => `+${omittedValues.length} more`} // display for extra
            />
          </Form.Item>
          <Form.Item<NotificationCustomerFilterFormValues>
            label="Event"
            name={NotificationCustomerFilterFormField.EventIds}
          >
            <Select
              mode="multiple"
              style={{ width: "350px" }}
              showSearch
              loading={event_loading}
              placeholder="Select Event Name"
              className='cstm_select'

              options={eventList?.notificationDropDownList?.map((res: any) => ({
                label: res.title,
                value: res.id,
              }))}

              // ✅ Enable search by BOTH label + value
              filterOption={(input, option) => {
                const label = option?.label?.toString().toLowerCase() || "";
                const value = option?.value?.toString().toLowerCase() || "";

                return (
                  label.includes(input.toLowerCase()) ||
                  value.includes(input.toLowerCase())
                );
              }}

              onChange={(values: number[]) => {
                const searchKey = values.join(",");
                setCategorySearchKey(searchKey);
              }}

              maxTagCount={2}
              maxTagPlaceholder={(omittedValues) => `+${omittedValues.length} more`}
            />
          </Form.Item>
          <Form.Item<NotificationCustomerFilterFormValues>
            label={'Event Category'}
            name={NotificationCustomerFilterFormField.TicketCategoryIds}
          >
            <Select
              mode="multiple"
              style={{ width: "240px" }}
              showSearch
              loading={category_loading}
              placeholder="Select Category"
              className='cstm_select'


              options={categoryList?.notificationDropDownList?.map((res: any) => ({
                label: res.title, // ✅ MUST be string for search
                value: res.id,
              }))}

              // ✅ Search by title + id
              filterOption={(input, option) => {
                const label = option?.label?.toString().toLowerCase() || "";
                const value = option?.value?.toString().toLowerCase() || "";

                return (
                  label.includes(input.toLowerCase()) ||
                  value.includes(input.toLowerCase())
                );
              }}

              // ✅ UI truncate (instead of modifying label)
              optionRender={(option) => {
                const title = option.label as string;

                return (
                  <span title={title}>
                    {title.length > 15 ? `${title.slice(0, 15)}...` : title}
                  </span>
                );
              }}

              maxTagCount={1}
              maxTagPlaceholder={(omittedValues) => `+${omittedValues.length} more`}


            />
          </Form.Item>

          <Form.Item<NotificationCustomerFilterFormValues>
            label={'Gender'}
            name={NotificationCustomerFilterFormField.GenderId}
          >
            <Select
              placeholder="Please select"
              style={{ width: "100%" }}
              loading={genderLoading}
              options={gender?.notificationDropDownList?.map((res: any) => ({
                label: res.title,
                value: res.id
              }))}
            />
          </Form.Item>
          <Form.Item<NotificationCustomerFilterFormValues>
            label={'Payment Status'}
            name={NotificationCustomerFilterFormField.PAYMENT_STATUS}

          >
            <Select
            defaultValue={'Complete'}
              placeholder="Please select"
              style={{ width: "100%" }}
              options={[
                { label: 'Complete', value: '1' },
                { label: 'Incomplete', value: '2' }
              ]}
              allowClear
            />
          </Form.Item>



          <Form.Item<NotificationCustomerFilterFormValues>
            label={'Age Group'}
            name={NotificationCustomerFilterFormField.AgeGroupIds}
          >
            <Select
              mode="multiple"

              loading={ageGroupLoading}
              placeholder="Please select"
              style={{ width: "180px" }}

              options={ageGroupCategory?.notificationDropDownList?.map((res: any) => ({
                label: res.title,
                value: res.id

              }))}
              maxTagCount={1} // ✅ keep UI clean
              maxTagPlaceholder={(omittedValues) => `+${omittedValues.length} more`}
              maxTagTextLength={5}
            />
          </Form.Item>
          <Form.Item<NotificationCustomerFilterFormValues>
            label={'Nationality'}
            name={NotificationCustomerFilterFormField.Nationality}
          >
            <Select
              showSearch
              placeholder="Select Type"
              style={{ width: "100%" }}
              options={nationality?.notificationDropDownList?.map((res: any) => ({

                label: res.title,
                value: res.title
              }))}

              optionFilterProp="label"

              allowClear
            > </Select>
          </Form.Item>


          {screens.lg && (
            <ContentFilters.ButtonsWrapper style={{ justifyContent: 'left' }}>
              <Button type='primary' htmlType='submit'>
                {t('common.buttons.filter', { count: 1 })}
              </Button>
              <Button onClick={onReset}>{t('common.buttons.reset')}</Button>
            </ContentFilters.ButtonsWrapper>
          )}
        </StandardItemsWrapper>
      </ContentFilters.FormItemsWrapper>
    </Form>
  );
};
